/**
 * Created by Alex Aguilar on 7/14/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig)

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('specialFlights',{
                parent: 'app',
                url: '/specialFlights',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminFlight/specialFlight/specialFlights.html',
                        controller: 'specialFlightsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('adminFlights')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['specialFlight']);
                            }],
                            'routes': ['routeService', function(routeService){
                                return routeService.getRoutes()
                            }],
                            'structures': ['structureSeatMapService', function(structureSeatMapService){
                                return structureSeatMapService.getStructuresByModelAircraft()
                            }],
                            'loadFormCreate': ['flightService', function(flightService){
                                return flightService.getLoadFormCreate()

                            }]
                        }
                    }
                }
            })
    }
})();
